<template>
  <div class="recentLiveContainer">
    <div v-if="showEmpty">
      <van-skeleton v-for="(item, index) in 3" :key="index" title avatar row="3" />
    </div>
    <div class="recentLive" v-if="tabList">
      <div class="hotClass" v-show="isShow">
        <p
          v-for="(item, index) in tabList"
          :key="index"
          :class="[tabIndex === index ? 'tabActive' : '']"
          @click="tabClick(index)"
        >
          {{ item }} <span></span>
        </p>
        <div @click="moreLive">更多<img src="@/assets/img/arkHome/more.png" alt="" /></div>
      </div>
      <template v-if="tabIndex === 0">
        <!-- 首页直播s -->
        <div v-show="isShow">
          <ul class="liveList">
            <li
              v-for="(item, index) in openCourseList.slice(0, showLiveNum)"
              :key="index"
              @click="jumpCourseDetail(item.productId, item)"
            >
              <div class="teacherImg" v-if="item.teacherRespVOS">
                <div
                  class="teacherImg-bg"
                  :class="{ teacherBg2: showTeacherBg2(index), teacherBg3: showTeacherBg3(index) }"
                >
                  <span>{{ item.teacherRespVOS[0].name }}</span>
                </div>
                <img :src="item.teacherRespVOS[0].topicWebHead || defaultImg" alt="" />
              </div>
              <div class="liveInfo">
                <h2 class="liveName">
                  <i v-if="item.title.substr(0, 1) === '【'"></i>{{ item.title }}
                </h2>
                <dl class="liveTimeNum">
                  <dd>
                    <span
                      >{{ dayCount(item.startTime.slice(0, 10)) }}
                      {{ item.startTime.slice(10, 16) }}</span
                    >
                  </dd>
                </dl>
                <div class="liveBtn">
                  <div>
                    <span v-if="item.sellPrice != 0">￥{{ item.sellPrice }}</span>
                    <span v-if="item.sellPrice === 0">免费</span>
                    <span class="pcount"
                      >{{ Number(item.realSales) + Number(item.initialSales) }}人已报名</span
                    >
                  </div>
                  <div
                    class="goLive"
                    @click.stop="lookCourse(item)"
                    :class="[item.isExistsLiving ? 'liveMake' : 'classReminder']"
                  >
                    <img :src="showIcon(item)" alt="" />
                    <span> {{ showBtnText(item) }}</span>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <!-- 首页直播end -->
        <!-- 直播列表s -->
        <div v-show="!isShow">
          <div v-for="items in courseArr" :key="items.date">
            <div class="timehead">
              <em></em><span>{{ dayCount(items.date) }}</span>
            </div>
            <ul class="liveList">
              <li
                v-for="(item, index) in items.courseList"
                :key="index"
                @click="jumpCourseDetail(item.productId, item)"
              >
                <div class="teacherImg">
                  <div
                    class="teacherImg-bg"
                    :class="{
                      teacherBg2: showTeacherBg2(index),
                      teacherBg3: showTeacherBg3(index),
                    }"
                  >
                    <span>{{ item.teacherRespVOS[0].name }}</span>
                  </div>
                  <img :src="item.teacherRespVOS[0].topicWebHead || defaultImg" alt="" />
                </div>
                <div class="liveInfo">
                  <h2 class="liveName">
                    <i v-if="item.title.substr(0, 1) === '【'"></i>{{ item.title }}
                  </h2>
                  <dl class="liveTimeNum">
                    <dd>
                      <span>{{ item.startTime.slice(5, 16) }}</span>
                    </dd>
                  </dl>
                  <div class="liveBtn">
                    <div>
                      <span v-if="item.sellPrice != 0">￥{{ item.sellPrice }}</span>
                      <span v-if="item.sellPrice === 0">免费</span>
                      <span class="pcount"
                        >{{ Number(item.realSales) + Number(item.initialSales) }}人已报名</span
                      >
                    </div>
                    <div
                      class="goLive"
                      @click.stop="lookCourse(item)"
                      :class="[item.isExistsLiving ? 'liveMake' : 'classReminder']"
                    >
                      <img :src="showIcon(item)" alt="" />
                      <span> {{ showBtnText(item) }}</span>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <!--直播列表end -->
      </template>
      <template v-if="tabIndex === 1">
        <div ref="wrapper" class="fatherProject">
          <div class="projectBox" ref="contPro">
            <ProjectCard
              v-for="(item, index) in porjectList"
              :key="index"
              :projectInfo="item"
              :useWhere="1"
              @click.native="goPojectDetial(item)"
            />
          </div>
        </div>
      </template>

      <!-- loading -->
      <Loading ref="load" />
      <!--  -->
      <Association v-if="showGroup" :courseInfo="newCourseInfo" @closeGroup="closeGroup" />
      <!-- 开播提醒弹框 -->
      <ClassRemind v-if="isRemindBox" :courseInfo="newCourseInfo" @closeRemindBox="closeRemindBox" />
      <OpenMember ref="member" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import {
  reqAdvertPlaying,
  reqOpenCourseLive,
  reqProtrialCourse,
  reqProtrialAccumulate,
} from '@/api/home';
import { reqSubOrder, reqPrice } from '@/api/pay';
import { reqIsBuyProduct } from '@/api/courseDetail';
import { gioJumpType, setTokenFromCookie, gioPlatform, setBaseUrl } from '@/utils/tools';
import ClassRemind from '@/components/classRemind/index.vue';
import defaultImg from '../../../assets/img/arkHome/live-tea-bg.png';
import Loading from '../../../components/loading/loading.vue';
import Association from './association.vue';
import ProjectCard from './projectCard.vue';
import OpenMember from './openMember.vue';

const pageYear = window.location.pathname.indexOf('ark/home') !== -1 ? 24 : 23;

export default {
  props: {
    numLength: {
      type: Boolean,
      default: true,
    },
    isShow: {
      type: Boolean,
      default: true,
    },
    courseList: {
      type: Array,
      default: () => [],
    },
    classCode: {
      type: [Number, String],
      default: 0,
    },
    examType: {
      // 考研年份
      type: [Number, String],
      default: 23,
    },
  },
  data() {
    return {
      openCourseList: [], // 公开课列表
      courseArr: [], // 直播列表页
      newCourseInfo: {}, // 当前点击的课程信息
      showLiveNum: 0, // 展示数量
      buyStatus: [], // 购买状态
      disbaled: false, // 控制按钮状态
      gioVisitUserId: '',
      defaultImg,
      openCourseId: 0, // 开课记录id 1
      showGroup: false,
      showEmpty: true,
      dayshow: true,
      iconlist: [
        'https://iqh-zt-pord-cdn.iqihang.com/homeUI/live.gif',
        'https://iqh-zt-pord-cdn.iqihang.com/homeUI/appoint.png',
        'https://iqh-zt-pord-cdn.iqihang.com/homeUI/remind.png',
      ],
      tabIndex: 0, // 0直播公开课,1精品专题课
      porjectList: [], // 精品专题课列表
      isRemindBox: false,
      insertLiveCourseToCalendarInfo: [],
    };
  },
  components: {
    Loading,
    Association,
    ProjectCard,
    ClassRemind,
    OpenMember,
  },
  computed: {
    ...mapState(['userInfo', 'actionType', 'courseInfo']),
    user() {
      return { ...this.userInfo };
    },
    tabList() {
      let tab = null;
      if (this.openCourseList.length && this.porjectList.length) {
        tab = ['直播公开课', '精品专题课'];
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.tabIndex = 0;
      } else if (this.openCourseList.length && !this.porjectList.length) {
        tab = ['直播公开课'];
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.tabIndex = 0;
      } else if (!this.openCourseList.length && this.porjectList.length) {
        tab = ['', '精品专题课'];
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.tabIndex = 1;
      } else {
        tab = null;
      }

      return tab;
    },
  },
  watch: {
    userInfo: {
      async handler(newVal) {
        if (newVal.id && this.actionType === 1) {
          await this.getOpenCourse();
          this.newCourseInfo = this.openCourseList.find((item) => item.id === this.courseInfo.id);
          this.lookCourse(this.newCourseInfo);
          this.$store.dispatch('save_course_info', {});
        }
      },
      deep: true,
      immediate: true,
    },
    examType: {
      handler(v) {
        if (v === 24 || v === 25) {
          this.getProtrialCourse();
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.getOpenCourse();
    const that = this;
    setTimeout(() => {
      // 获取登录状态
      window['iqhApp2jsBridge.triggerSC'].getLogin = that.getLogin;
      window['iqhApp2jsBridge.triggerSC'].onCalendarPermissions = that.onCalendarPermissions;
    }, 100);
    if (this.$root.$data.isApp) {
      this.$sendToApp('getGIoVisitUserId', false);
    }
    window.setGIoVisitUserId = (value) => {
      this.getAndroid(value);
    };
    this.getUUid();
  },
  methods: {
    // 日历权限回调
    onCalendarPermissions(value) {
      if (Number(value) === 1) {
        this.$sendToApp('insertLiveCourseToCalendar', this.insertLiveCourseToCalendarInfo);
      }
    },
    showRemindBox() {
      // 打开开播提醒
      this.isRemindBox = true;
    },
    closeRemindBox() {
      // 关闭开播提醒
      this.isRemindBox = false;
    },
    tabClick(index) {
      this.tabIndex = index;
      if (index === 1) {
        this.gioProjectCourse(1);
      }
    },
    async getProtrialCourse() {
      const data = {
        pageNum: 1,
        pageSize: 5,
      };
      const res = await reqProtrialCourse(data);
      if (res?.code === 0) {
        if (res?.data) {
          this.porjectList = res?.data.data;
        } else {
          this.tabList = ['直播公开课'];
        }
      }
    },
    getAndroid(value) {
      if (this.$root.$data.isApp) {
        this.gioVisitUserId = `{u:'${value || ''}', roomId: '${
          this.$route.query.liveRoomId || ''
        }'}`;
      }
    },
    getUUid() {
      if (!this.$root.$data.isApp) {
        // eslint-disable-next-line
        let uuid = gio('getVisitUserId') || [];
        this.gioVisitUserId = `{u:'${uuid[0] || ''}', roomId: '${
          this.$route.query.liveRoomId || ''
        }'}`;
      }
    },

    // 请求公开课
    async getOpenCourse() {
      let paramsList = ['App00005'];
      if (Number(this.classCode) === 8) {
        paramsList = ['App240006'];
      } else if (Number(this.classCode) === 10) {
        paramsList = ['App25006'];
      } else if (Number(this.classCode) === 12) {
        paramsList = ['App26006'];
      }
      try {
        const res = await reqAdvertPlaying(paramsList);
        if (res.code === 0 && res.data) {
          this.currentTime = res.currentTime?.slice(0, 10); // 当前时间
          this.openCourseList =
            res.data.find((item) => item.adCode === paramsList[0])
              ?.advertisingContentWebInfoRespVOS || [];
          // 首页 直播课
          this.showLiveNum = this.openCourseList.length > 3 ? 3 : this.openCourseList.length;
          if (!this.isShow) {
            this.pageList();
          }
          gio('track', 'adShown_event', {
            adPosition_var: `${this.examType}考研-首页-直播公开课`, // 广告位置
            pageName_var: '首页', // 页面名称
            adSequence_var: 0, // 广告序号
            adId_var: this.openCourseList[0]?.id.toString(), // 广告ID
            adName_var: paramsList[0].toString(), // 广告名称
            linesBusiness_var: '考研', // 业务线
            jumpType_var: '', // 跳转类型
            platform_var: gioPlatform(),
          });
        }
      } catch (error) {
        console.log(error);
      }
      this.showEmpty = false;
    },
    // 直播列表页数据
    pageList() {
      // 排序
      this.dayshow = false;
      this.openCourseList = this.openCourseList.sort((a, b) =>
        a.startTime < b.startTime ? -1 : 1,
      );
      const map = new Map();
      // eslint-disable-next-line no-restricted-syntax
      for (const item of this.openCourseList) {
        const date = item.startTime.slice(0, 10);
        const mapValue = map.get(date);

        if (mapValue) {
          mapValue.push(item);
        } else {
          map.set(date, [item]);
        }
      }
      // map 转数组
      const result = [];
      // eslint-disable-next-line no-restricted-syntax
      for (const key of map.keys()) {
        result.push({
          date: key,
          courseList: map.get(key),
        });
      }
      this.courseArr = result;
    },
    // unfoldFold(text) {
    //   if (text === '更多直播') {
    //     this.unfoldFoldText = '收起';
    //     this.showLiveNum = this.openCourseList.length;
    //   } else {
    //     this.unfoldFoldText = '更多直播';
    //     this.showLiveNum = 2;
    //   }
    // },
    // app内开课提醒
    async handAppOpenCourse(containCurriculumId) {
      const res = await reqOpenCourseLive(containCurriculumId, 1);
      this.insertLiveCourseToCalendarInfo = res?.data?.length
        ? res?.data?.map((item) => ({
            liveName: item?.name,
            liveStartTime: item?.startTime,
            liveEndTime: item?.endTime,
          }))
        : [];
      if (res?.data?.length) {
        this.$sendToApp('queryCalendarPermissions', true);
      } else {
        this.$toast('课程内暂无直播，请耐心等待');
      }
    },
    lookCourse(courseInfo) {
      const {
        coursesRecordVO,
        isExistsLiving,
        sellPrice,
        productId,
        productSkuSimpleVOS,
        containCurriculumId,
      } = courseInfo;
      this.$store.dispatch('save_course_info', courseInfo);
      this.newCourseInfo = courseInfo;
      // 校验是否登录
      if (!this.userInfo?.id) {
        // 区分App和h5
        if (this.$root.$data.isApp) {
          this.$sendToApp('login', {}, true)
            .then(async () => {
              setTokenFromCookie();
              await this.$root.getUserInfo();
            })
            .catch((err) => console.log(err.toString()));
        } else {
          // H5
          this.jumpLogin();
        }
        return;
      }
      // 已购买 -直播未开始
      if (coursesRecordVO && !isExistsLiving) {
        if (this.$root.$data.isApp) {
          this.handAppOpenCourse(containCurriculumId);
        } else {
          this.showRemindBox();
          // window.open('weixin://dl/business/?t=ZtXZb3rT6hn');
        }
        return;
      }
      // 已购买 -直播开始
      if (coursesRecordVO && isExistsLiving) {
        this.getCatalog(courseInfo);
        return;
      }
      // 校验是否多sku
      if (!coursesRecordVO && productSkuSimpleVOS?.length > 1) {
        if (this.$root.$data.isApp) {
          this.$sendToApp('goCourseDetail', Number(productId), false);
          return;
        }
        this.$router.push({
          path: '/courseDetail',
          query: {
            courseId: productId,
          },
        });
        return;
      }
      // 免费课 直播未开始，用户未预约
      if (productSkuSimpleVOS.length === 1 && sellPrice === 0) {
        this.freeCourseReceive(courseInfo);
      } else {
        this.payOrder(courseInfo);
      }
    },
    // 跳转H5登录
    jumpLogin() {
      if (!this.isShow) {
        this.$router.push({
          name: 'registrationLogin',
          query: { redirect: `/recentMoreLiveCourse?classCode=${this.classCode}` },
        });
        return;
      }
      this.$router.push({ name: 'registrationLogin', query: { redirect: '/home' } });
    },
    // 免费课购买
    async freeCourseReceive(courseInfo) {
      if (this.disbaled === true) {
        return;
      }
      this.disbaled = true;
      const { productId, productSkuSimpleVOS, isExistsLiving } = courseInfo;
      let referer = '';
      if (sessionStorage.getItem('fromPageUrl')) {
        const paramData = JSON.parse(sessionStorage.getItem('fromPageUrl'));
        referer = paramData.fromPageUrl ? paramData.fromPageUrl : paramData.fromPageUrlLast;
      }

      const subData = {
        channelMark: 5,
        products: [
          {
            productId,
            quantity: 1,
            type: 1,
          },
        ],
        terminalMark: this.$global.terminalMark,
        // eslint-disable-next-line no-undef
        ip: sessionStorage.getItem('cityIp') || '',
        orderReferer: referer,
        orderUrl: window.location.href,
        extendParam: this.gioVisitUserId,
      };
      subData.products[0].productSkuId = productSkuSimpleVOS[0].productSkuId;
      // const { liveRoomId } = this.$route.query;
      // if (liveRoomId) subData.extendParam = JSON.stringify({ roomId: liveRoomId });
      this.$refs.load.show = true;
      const res = await reqSubOrder(subData);
      if (res.code === 0) {
        this.disbaled = false;
        setTimeout(() => {
          this.$toast.success('预约成功');
          // 更新开课状态
          this.$refs.load.show = false;
          this.getOpenCourse();
          if (isExistsLiving) {
            const liveCourseInfo = this.openCourseList.find(
              (item) => item.id === this.courseInfo.id,
            );
            this.checkBuyCourse(liveCourseInfo);
          } else if (this.$root.$data.isApp) {
            this.$sendToApp(
              'showCommunityInfo',
              { productId, productSkuId: productSkuSimpleVOS[0].productSkuId },
              false,
            );
          } else {
            this.showGroup = true;
          }
        }, 2000);
      } else {
        this.disbaled = false;
        this.$refs.load.show = false;
        this.$toast.fail(res.msg);
      }
    },
    // 校验课程是否购买
    async checkBuyCourse(courseInfo) {
      const { productId } = courseInfo;
      const res = await reqIsBuyProduct(productId);
      if (res.code === 0 && res.data.length) {
        this.buyStatus = res.data;
        this.getCatalog(courseInfo);
      }
    },
    // 下单页
    payOrder(courseInfo) {
      const { productId, productSkuSimpleVOS, containCurriculumId } = courseInfo;
      // 存储课表id在支付成功页使用
      sessionStorage.setItem('containCurriculumId', containCurriculumId);
      if (!productSkuSimpleVOS.length) {
        this.$toast('已售罄');
        return;
      }
      if (this.$root.$data.isApp) {
        this.$sendToApp(
          'buyCourseNew',
          {
            product: JSON.stringify([
              {
                productId,
                skuId: productSkuSimpleVOS?.[0]?.productSkuId,
              },
            ]),
          },
          false,
        );
        this.gioDefault(productId, productSkuSimpleVOS);

        return;
      }
      this.$router.push({
        path: '/payOrder',
        query: {
          product: JSON.stringify([
            {
              productId,
              skuId: productSkuSimpleVOS?.[0]?.productSkuId,
            },
          ]),
        },
      });
      this.gioDefault(productId, productSkuSimpleVOS);
    },
    // 查询是否有多个直播
    async getCatalog(courseInfo) {
      const { containCurriculumId, coursesRecordVO, productId } = courseInfo;
      const res = await reqOpenCourseLive(containCurriculumId, 2);
      if (res.code === 0 && res?.data?.length) {
        this.videoList = res.data;
        this.videoList.forEach((element) => {
          Object.assign(element, { courseId: productId });
        });
        // 课程在可重复购买时 coursesRecordVO 为null  因此checkBuyCourse方法取用户的开课记录
        this.openCourseId = coursesRecordVO
          ? coursesRecordVO.openCoursesRecordList[0].id
          : this.buyStatus[0].id;
        sessionStorage.setItem('openCourseId', this.openCourseId);
        this.openLiveRoom(this.videoList, this.openCourseId);
      } else {
        this.$toast('未查询到直播信息');
      }
    },
    // 打开直播
    openLiveRoom(videoList, ID) {
      if (videoList.length > 1) {
        // this.showLive = true;
        this.$emit('openLive', {
          videoList,
          openCourseRecordId: ID,
        });
      } else {
        const { roomId, name, id, courseId, curriculumNodeId, templateType, resourceSource } =
          videoList[0];
        if (this.$root.$data.isApp) {
          const query = {
            liveName: name, // 直播名称
            openCourseRecordId: ID, // 开课记录id
            productId: '', // 产品id
            roomId, // 直播间id
            liveId: id, // 直播id
            chapterId: curriculumNodeId, // 章节id
            productName: '',
          };
          // 进入直播
          this.$sendToApp('goLiveRoomPage', query, false);
        } else {
          if (resourceSource === 2) {
            this.$router.push({
              path: '/liveBJY',
              query: {
                roomId,
                courseId,
                liveId: id,
                chapterId: curriculumNodeId,
                liveName: name,
                templateType,
              },
            });
            return;
          }
          // 区分是三分屏 或者大视频
          const path = templateType === 4 || templateType === 5 ? '/threeScreenLive' : '/live';
          this.$router.push({
            path,
            query: {
              roomId,
              courseId,
              liveId: id,
              chapterId: curriculumNodeId,
              liveName: name,
            },
          });
        }
      }
    },
    // 详情页
    jumpCourseDetail(productId, item) {
      // 判断是否App
      if (this.$root.$data.isApp) {
        this.$sendToApp('goCourseDetail', Number(productId), false);
        this.gioEvent(item);
        return;
      }
      this.$router.push({
        path: '/courseDetail',
        query: {
          courseId: productId,
          beforePageName: 3,
        },
      });
      // 存session 控制返回
      sessionStorage.setItem('liveCourse', true);
      this.gioEvent(item);
    },
    async getLoginAfter() {
      await this.$root.getUserInfo();
    },
    // ios 处理登录回调
    getLogin(APPSESSION) {
      const cookieToken = APPSESSION;
      if ((window?.navigator?.userAgent || '').includes('iqihang')) {
        window.localStorage.setItem('accessToken', cookieToken || '');
        this.getLoginAfter();
      }
    },
    async gioDefault(productId, productSkuSimpleVOS) {
      const res = await reqPrice({
        promotionBasicPrice: {
          endPoint: this.$root.$data.isApp ? 2 : 3,
          platform: 1,
        },
        promotionProductSkuPriceList: [
          {
            productId,
            skuId: productSkuSimpleVOS[0].productSkuId,
          },
        ],
      });
      if (res.code === 0) {
        const courseIdList = [];
        const courseNameList = [];
        const allianceId = [];
        const allianceName = [];
        const fullReductionId = [];
        const fullReductionName = [];
        const secondsKillNameList = [];
        const {
          orderPayPrice,
          orderTotalPrice,
          productCalculateResultRespList,
          fullDiscountPrice,
          unionDiscountPrice,
          unionCalculateResultRespList,
          promotionFullCalculateResultRespList,
          singleCalculateResultRespList,
        } = res.data;
        productCalculateResultRespList.forEach((element) => {
          courseIdList.push(element.productId);
          courseNameList.push(element.productName);
        });
        if (unionDiscountPrice) {
          unionCalculateResultRespList.forEach((element) => {
            allianceId.push(element.promotionId);
            allianceName.push(element.promotionName);
          });
        }
        if (fullDiscountPrice) {
          promotionFullCalculateResultRespList.forEach((element) => {
            fullReductionId.push(element.promotionId);
            fullReductionName.push(element.promotionName);
          });
        }
        if (singleCalculateResultRespList) {
          singleCalculateResultRespList.forEach((element) => {
            if (element.promotionLabel === 2 || element.promotionLabel === 3) {
              secondsKillNameList.push(element.promotionName);
            }
          });
        }
        // 立即购买埋点
        // eslint-disable-next-line
        gio('track', 'buyCourse_event', {
          courseIdList_var: courseIdList.toString(), // 课程 ID 列表
          courseNameList_var: courseNameList.toString(), // 课程名称列表
          courseTotalPrice_var: secondsKillNameList.length > 0 ? orderPayPrice : orderTotalPrice, // 课程总价
          isAlliance_var: unionDiscountPrice ? '是' : '否', // 是否参加联报
          allianceId_var: unionDiscountPrice ? allianceId.toString() : null, // 联报活动ID
          allianceName_var: unionDiscountPrice ? allianceName.toString() : null, // 联报活动名称
          allianceDiscountAmount_var: unionDiscountPrice || null, // 联报优惠金额
          isSecondsKill_var: secondsKillNameList.length > 0 ? '是' : '否', // 是否参加秒杀
          secondsKillNameList_var:
            secondsKillNameList.length > 0 ? secondsKillNameList.toString() : null, // 秒杀活动名称列表
          isFullReduction_var: fullDiscountPrice ? '是' : '否', // 是否参加满减
          fullReductionId_var: fullDiscountPrice ? fullReductionId.toString() : null, // 满减活动ID
          fullReductionName_var: fullDiscountPrice ? fullReductionName.toString() : null, // 满减活动名称
          fullReductionAmount_var: fullDiscountPrice || null, // 满减优惠金额
          platform_var: gioPlatform(),
        });
      }
    },
    gioEvent(item) {
      const { title, skipType } = item;
      const adId = item.id;
      // 点击广告
      // eslint-disable-next-line
      gio('evar.set', 'liveRecommend_evar', title);
      // eslint-disable-next-line
      gio('track', 'adClick_event', {
        adPosition_var: `${pageYear}考研-首页-公开课`, // 广告位置
        pageName_var: '首页', // 页面名称
        adSequence_var: null, // 广告序号
        adId_var: adId.toString(), // 广告ID
        adName_var: title, // 广告名称
        linesBusiness_var: '考研', // 业务线
        jumpType_var: gioJumpType(skipType), // 跳转类型
        platform_var: gioPlatform(),
      });
    },
    gioProjectCourse(type) {
      // type :1 广告曝光 ，2 广告点击
      const projectIdList = [];
      const projectNameList = [];
      // eslint-disable-next-line no-unused-expressions
      this.porjectList?.map((item) => {
        projectIdList.push(item.id);
        projectNameList.push(item.title);
      });
      if (type === 1) {
        // 广告曝光
        // eslint-disable-next-line
        gio('track', 'adShown_event', {
          adPosition_var: '精品专题课', // 广告位置
          pageName_var: '首页', // 页面名称
          adSequence_var: null, // 广告序号
          adId_var: projectIdList.toString(), // 广告ID
          adName_var: projectNameList.toString(), // 广告名称
          linesBusiness_var: '考研', // 业务线
          jumpType_var: '其他', // 跳转类型
          platform_var: gioPlatform(),
        });
      } else {
        // eslint-disable-next-line
        gio('track', 'adClick_event', {
          adPosition_var: '精品专题课', // 广告位置
          pageName_var: '首页', // 页面名称
          adSequence_var: null, // 广告序号
          adId_var: projectIdList.toString(), // 广告ID
          adName_var: projectNameList.toString(), // 广告名称
          linesBusiness_var: '考研', // 业务线
          jumpType_var: '其他', // 跳转类型
          platform_var: gioPlatform(),
        });
      }
    },
    showBtnText(data) {
      const { isExistsLiving, coursesRecordVO } = data;
      let text = '';
      if (isExistsLiving) {
        text = '正在直播';
      } else if (coursesRecordVO) {
        text = '开课提醒';
      } else {
        text = '预约报名';
      }
      return text;
    },
    showIcon(data) {
      const { isExistsLiving, coursesRecordVO } = data;
      let src = '';
      if (isExistsLiving) {
        // eslint-disable-next-line prefer-destructuring
        src = this.iconlist[0];
      } else if (coursesRecordVO) {
        // eslint-disable-next-line prefer-destructuring
        src = this.iconlist[1];
      } else {
        // eslint-disable-next-line prefer-destructuring
        src = this.iconlist[2];
      }
      return src;
    },
    closeGroup() {
      this.showGroup = false;
    },
    // 更多
    moreLive() {
      if (this.tabIndex === 1) {
        // 精品专题课
        this.$router.push({ path: '/projectCourseList' });
        return;
      }
      // 校验是否登录
      if (!this.userInfo?.id) {
        // 区分App和h5
        if (this.$root.$data.isApp) {
          this.$sendToApp('login', {}, true)
            .then(async () => {
              setTokenFromCookie();
              await this.$root.getUserInfo();
              // this.lookCourse(this.courseInfo);
            })
            .catch((err) => console.log(err.toString()));
        } else {
          // H5
          this.jumpLogin();
        }
      } else {
        if (this.$root.$data.isApp) {
          this.$sendToApp(
            'openNewWebView',
            { url: `${setBaseUrl('')}/ark/recentMoreLiveCourse?classCode=${this.classCode}` },
            false,
          );
          return;
        }
        this.$router.push({ path: '/recentMoreLiveCourse', query: { classCode: this.classCode } });
      }
    },
    goPojectDetial(item) {
      // 校验是否登录
      if (!this.userInfo?.id) {
        // 区分App和h5
        if (this.$root.$data.isApp) {
          this.$sendToApp('login');
        } else {
          // H5
          this.$router.push({ path: '/registrationLogin', query: { redirect: '/home' } });
        }
      } else {
        if (item.memberLevel && this.userInfo.level !== 30) {
          this.$refs.member.showPop = true;
          return;
        }
        this.gioProjectCourse(2);
        // 精品专题课列表
        this.$router.push({
          path: '/projectDetail',
          query: {
            projectId: item.id,
          },
        });
      }
    },

    showTeacherBg2(idx) {
      let flag = '';
      if (idx % 3 === 1) {
        flag = true;
      }
      return flag;
    },
    showTeacherBg3(idx) {
      let flag = '';
      if (idx % 3 === 2) {
        flag = true;
      }
      return flag;
    },
    dayCount(time) {
      const { currentTime } = this;
      let day = '';
      const currenTime = new Date(currentTime).getTime();
      const getTime = new Date(time).getTime();
      if (currenTime - getTime === 0) {
        day = '今天';
      } else if (getTime - currenTime === 86400000) {
        // 年月日相差 86400000  如 2022-03-10与2022-03-11相差86400000
        day = '明天';
      } else {
        day = this.dayshow ? time.slice(5) : time;
      }
      return day;
    },
  },
};
</script>

<style lang="scss" scoped>
.recentLiveContainer {
  padding-top: 20px;
  background: #f8f8f8;
}
.recentLive {
  padding: 32px 40px 0 40px;
  background: #fff;
}
.hotClass {
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  padding-bottom: 30px;
  overflow: hidden;
  line-height: 50px;
  // background: $bgWhite;
}

.hotClass > p {
  /* width: 4.85px; */
  float: left;
  margin-right: 40px;
  color: $fontColorBlack;
  font-weight: bold;
  font-size: 32px;
}
.tabActive {
  color: #ff7f41 !important;
  span {
    display: block;
    width: 40px;
    height: 6px;
    margin: 8px auto 0 auto;
    background: #ff7f41;
    border-radius: 3px;
  }
}
.hotClass > div {
  float: right;
  width: 20%;
  color: $fontColorGray;
  font-size: 24px;
  text-align: right;
}
.hotClass > div img {
  display: inline-block;
  width: 20px;
  height: 20px;
}
// 新直播样式
.liveList {
  li {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-bottom: 2px solid #f8f8f8;
  }
  li:last-of-type {
    border-bottom: none;
  }
}
.teacherImg {
  position: relative;
  flex-shrink: 0;
  width: 136px;
  height: 136px;
  overflow: hidden;
  .teacherImg-bg {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 136px;
    height: 120px;
    background: url('../../../assets/img/arkHome/orange.png') top no-repeat;
    background-size: 100%;
  }
  span {
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 2;
    display: block;
    max-width: 136px;
    height: 36px;
    padding: 0 16px;
    overflow: hidden;
    color: #fff;
    font-size: 20px;
    line-height: 36px;
    white-space: nowrap;
    text-overflow: ellipsis;
    background: rgba(31, 32, 46, 0.5);
    border-radius: 0 20px 0 0;
  }
  .teacherBg2 {
    background: url('../../../assets/img/arkHome/blue.png') top no-repeat;
    background-size: 100%;
  }
  .teacherBg3 {
    background: url('../../../assets/img/arkHome/gray.png') top no-repeat;
    background-size: 100%;
  }
  img {
    position: absolute;
    left: -26px;
    // height: 218px;
    z-index: 1;
    width: 200px;
  }
}
.liveInfo {
  margin-left: 20px;
}
.liveName {
  width: 458px;
  overflow: hidden;
  color: $fontColorBlack;
  font-weight: bold !important;
  font-size: 32px;
  line-height: 40px;
  white-space: nowrap;
  text-overflow: ellipsis;
  i {
    margin-left: -18px;
  }
}
.tea-desc {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 14px;
  span {
    padding-right: 10px;
    color: #333;
    font-weight: 600;
    font-size: 28px;
  }
  b {
    position: relative;
    top: 1px;
    padding-left: 10px;
    color: #979797;
    font-weight: 400;
    font-size: 24px;
  }
  b::before {
    position: absolute;
    top: 1px;
    left: 0;
    display: block;
    width: 2px;
    height: 20px;
    font-weight: 400;
    font-size: 20px;
    // border-left: 1px solid #aaa;
    background: #979797;
    content: '';
  }
}
.leftSty {
  margin-left: -18px !important;
}
.liveTimeNum {
  display: flex;
  align-items: center;
  height: 32px;
  margin: 14px 0 14px 0;
  dd {
    display: flex;
    align-items: center;
    margin-right: 42px;
    img {
      margin-right: 9px;
    }
    .liveTime {
      width: 22px;
      height: 22px;
    }
    .liveNum {
      width: 25px;
      height: 24px;
    }
    span {
      display: inline-block;
      height: 36px;
      padding: 0 8px;
      color: $liveColor;
      font-size: 24px;
      line-height: 38px;
      white-space: nowrap;
      background: $orangeBg;
      border-radius: 8px;
    }
  }
}
.liveAndroid {
  .liveTime {
    position: relative;
    top: -2px;
  }
  .liveNum {
    position: relative;
    top: -2px;
  }
}
.liveBtn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 510px;
  height: 40px;
  div {
    font-size: 0;
    span:first-of-type {
      font-weight: bold;
    }
  }
  span {
    display: inline-block;
    height: 40px;
    color: $redColor;
    font-size: 29px;
    line-height: 40px;
  }
  .pcount {
    margin-left: 18px;
    color: $fontColorGray;
    font-size: 22px;
    white-space: nowrap;
  }
}
.goLive {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 160px;
  height: 46px;
  color: #fff;
  font-weight: 400;
  font-size: 24px;
  border-radius: 23px;
  span {
    display: block;
    color: #ff682f;
    font-size: 24px;
    line-height: 43px;
  }
  img {
    display: block;
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    margin-right: 4px;
  }
}

.liveMake {
  color: #fff;
  background: #ff7f41;
  border: 2px solid #ff7f41;
  span {
    color: #fff;
  }
}
.classReminder {
  color: #ff6c02;
  background: #fff;
  border: 1px solid #ff6c02;
}
.moreLive {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 26px;
  margin-bottom: 18px;
  color: #989898;
  font-size: 22px;
  .icon {
    margin-left: 7px;
  }
}
.timehead {
  display: flex;
  align-items: center;
  margin-top: 56px;
  margin-bottom: 22px;

  em {
    display: block;
    width: 8px;
    height: 24px;
    background: #ff7f41;
    border-radius: 4px;
  }

  span {
    display: block;
    margin-left: 10px;
    color: #111;
    font-weight: 500;
    font-size: 32px;
  }
}
.fatherProject {
  overflow-y: auto;
  .projectBox {
    display: flex;
    padding-bottom: 8px;
    ::v-deep .projectCenter {
      margin-right: 22px;
    }
  }
}
.fatherProject::-webkit-scrollbar {
  display: none;
}
</style>
